<template>
  <div class="company">
    <!-- S :: #wrap -->
    <div id="wrap">

        <!-- S :: header -->
        <header id="header_wrap">
            <div class="inner">
                <h1 class="hlogo"><router-link class="sr_only" to="/">TOMATO CREW</router-link></h1>

                <!-- GNB -->
                <div class="gnb_wrap">
                    <h2 class="sr_only">menu</h2>
                    <a href="javascript:void(0);" class="btn_open_menu"><span>메뉴열기</span></a>
                    <nav id="gnb" class="gnb">
                        <ul class="gnb_menu">
                            <li><router-link to="/">홈</router-link></li>
                            <li><router-link to="/products">제품</router-link></li>
                            <li><a v-bind:href="this.$store.state.blog_link" target="_blank">블로그</a></li>
                            <li><a v-bind:href="this.$store.state.job_link" target="_blank">인재채용</a></li>
                            <li class="on"><router-link to="/company">회사소개</router-link></li>
                        </ul>
                    </nav>
                </div>
                <!-- // GNB -->
                
                <div class="select_lang" v-if="false">
                    <button type="button" class="btn_select"><span>Kor</span></button>
                    <ul class="select_list">
                        <li class="on"><button type="button">Kor</button></li> <!-- 선택 시 .on 추가 -->
                        <li><button type="button">En</button></li>
                    </ul>
                </div>
            </div>
        </header>
        <!-- E :: header -->

        <!-- S :: container -->
        <div id="content_wrap">
            
            <!-- key_visual -->
            <div class="kv_wrap">
                <div class="kv_company">
                    <div class="kv_bg"></div>
                    <div class="kv_text">
                        <p class="txt">20년 넘게 스펙트로스코피 응용 기술을 파고 든 경험으로, 빛으로 얻을 수 있는
                            신체 정보의 한계를 극복하기 위해 토마토 크루는 오늘도 정진합니다.</p>
                    </div>
                </div>
            </div>
            <!-- // key visual -->

            <section class="section_company">
                <div class="cont_box right">
                    <div class="cont">
                        <strong class="title">비전</strong>
                        <div class="txt_box">
                            <p>
                                토마토 크루는 R&D 중심의 팹리스(Fabless) 디지털 헬스케어 기기 & 솔루션 기업입니다.
                            </p>
                            <p>
                                걱정없는 삶을 위해 토마토 크루는 NIR 분광학 기반 비침습성 연속 혈당 모니터링(NiCGM) 웨어러블 기기에 도전하고 있습니다.
                            </p>
                            <p>
                                20년 넘게 감마선 응용 기술을 파고 든 경험으로, 빛으로 얻을 수 있는 신체 정보의 한계를 극복하기 위해 토마토 크루는 오늘도 정진합니다.
                            </p>
                        </div>
                    </div>
                    <span class="img_box"><img src="../assets/images/img_company_01.jpg"></span>
                </div>
                <div class="cont_box ci">
                    <div class="cont">
                        <strong class="title">CI</strong>
                        <div class="txt_box">
                            <p>
                                안데스 산맥에서만 크던 작은 토마토는 세계에서 사랑받는 채소가 되었습니다. <br>
                                우리 가까이서 건강을 챙겨주는 토마토.<br class="sm_visible"> 바로 우리가 추구하는 가치이며 기업과 제품 이름에 이를 반영했습니다.</p>
                        </div>
                    </div>
                    <span class="img_box">
                        <img src="../assets/images/img_ci.jpg" class="thumb_pc">
                        <img src="../assets/images/img_ci_m.jpg" class="thumb_mo">
                    </span>
                </div>
                <div class="cont_box left">
                    <div class="cont">
                        <strong class="title">연혁</strong>
                        <div class="txt_box">
                            <p>
                                2017년 11월, <br>
                                애초 메딧이란 이름으로 창업하여 NIR 분광학 기반 비침습성 연속 혈당 모니터링(NiCGM) 기기의 컨셉 증명(Proof of Concepts)을 위한 R&D를 지속해 왔으며, 2019년 관련 특허를 취득했습니다.<br>
                                이제 시제품 제작 및 실 테스트를 준비하고 있으며 2022년 양산을 목표로 개발에 더욱 더 매진하고 있습니다.
                            </p>
                        </div>
                        <div class="noti_box">
                            <p><strong>특허번호</strong> 10-2033914, Continuous Glucose Monitor</p>
                            <p><strong>특허번호</strong> 10-2062646, Remote Patient Monitoring System</p>
                        </div>
                        <a href="https://www.notion.so/1-cb806a5f1a384974ad0d2a0050c807c4" target="_blank"><button type="button" class="btn_more">창업 이야기 보기</button></a>
                    </div>
                    <span class="img_box"><img src="../assets/images/img_company_02.jpg"></span>
                </div>

                <div class="cont_box crew">
                    <div class="cont">
                        <strong class="title">크루원</strong>
                        <div class="txt_box">
                            <p>
                                <strong>“미래 의료는 웨어러블 헬스케어가 <br class="sm_visible">지배할 것이고 <br class="lg_visible">토마토 크루가 <br class="sm_visible">그 리더가 될 것입니다.”</strong>
                            </p>
                        </div>
                        <ul class="crew_list">
                            <li>
                                <span class="thumb"><img src="../assets/images/crew_01.png"></span>
                                <div class="info_box">
                                    <strong class="name">김득원<span>Doug Kim</span></strong>
                                    <span class="duty">대표이사</span>
                                    <div class="info">
                                        Doug은 응용 엔지니어링 및  시스템 설계 분야에서 20년 이상 경험을 가지고 있습니다. 그는 토마토 크루 설립자 및 실무형 CEO로서 NiCGM 밴드 및 의료 서비스 솔루션 개발을 총괄 지휘하고 있습니다.
                                    </div>
                                </div>
                            </li>
                            <li>
                                <span class="thumb"><img src="../assets/images/crew_02.png"></span>
                                <div class="info_box">
                                    <strong class="name">홍성주<span>Sean Hong</span></strong>
                                    <span class="duty">사업이사</span>
                                    <div class="info">
                                        Sean은 전문 경영인으로서 IT&게임 기업 온네트를 1996년 창업했고 이후 다음게임 대표이사를 거쳐 현재 O2O 전문 IT 기업 팀오투 대표이사를 맡고 있습니다. 또한 토마토 크루 공동 설립자이기도 합니다.
                                    </div>
                                </div>
                            </li>
                            <li>
                                <span class="thumb"><img src="../assets/images/crew_03.png"></span>
                                <div class="info_box">
                                    <strong class="name">이현승<span>Yoda Lee</span></strong>
                                    <span class="duty">기술이사</span>
                                    <div class="info">
                                        Yoda는 고려대 물리학과 석사 졸업 후 미국 Fermilab, 스위스 CERN에서의 연구 경험을 바탕으로 IT 및 블록체인 플랫폼, 게임 등 다방면에 걸친 경험을 갖고 있는 풀스택 개발자입니다.
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
        <!-- E :: container -->

        <!-- S :: footer -->
        <footer id="footer_wrap">
            <div class="inner">
                <div class="f_cont">
                    <ul class="menu">
                        <li>
                            <strong>
                                <small>토마토 크루가 궁금하세요?</small>
                                문의하기
                            </strong>
                            <p>
                                <button type="button" v-on:click="txtCopy()">contact@tomatocrew.io</button>
                                <input type="text" class="txtCopy" value="contact@tomatocrew.io">
                            </p>
                        </li>
                        <li>
                            <strong>
                                <small>토마토 크루에 온보딩</small>
                                채용 지원하기
                            </strong>
                            <p><a v-bind:href="this.$store.state.job_link" target="_blank" title="채용지원 바로가기">채용사이트 바로가기</a></p>
                        </li>
                    </ul>

                    <p class="f_logo"><span>TOMOTO CREW</span></p>

                    <div class="corp_info">
                        <p style="padding-bottom:4rem;">
                          <a v-bind:href="this.$store.state.termOfUse_link" target="_blank" title="이용약관">이용약관</a>
                          <a v-bind:href="this.$store.state.privacyPolicy_link" target="_blank" title="개인정보처리 방침" style="padding-left:1rem;">개인정보처리 방침</a>
                        </p>
                        <p>토마토크루 주식회사</p>
                        <p>사업자 등록번호 : 171-88-00770​</p>
                        <p class="copyright">Copyright &copy; TomatoCrew Corp. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
        <!-- E :: footer -->

    </div>
    <!-- E :: #wrap -->
  </div>
</template>

<script>
export default {
  name: 'COMPANY',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    txtCopy: () => {
      var $copyTxt = document.querySelector(".txtCopy");
      $copyTxt.select();
      $copyTxt.setSelectionRange(0, 99999)
      document.execCommand("copy");

      if($('.txtCopy').parent().find('.toast_wrap').length < 1) {
        $('.txtCopy').parent().append('<div class="toast_wrap"></div>')
      }

      var $wrapper = $('.toast_wrap')
      var _msg = $('<div class="toast_inner">메일주소가 복사되었습니다</div>');
      var _msgBox = _msg.appendTo($wrapper)

      _msg.appendTo($wrapper)
      $wrapper.show();
      setTimeout(function () {
        _msgBox.addClass('active');
      },300)

      _msgBox.delay(1500).queue(function() {
        $(this).removeClass('active');
        if($(this).closest('.toast_wrap').find('.active').length < 1) {
          setTimeout(function () {
            $('.toast_wrap').remove();
          }, 400)	
        }
      })
    }
  },
  mounted() {
    $('.btn_open_menu').on('click',function () {
      if(!$(this).hasClass('open')) {
        $(this).addClass('open').siblings('.gnb').addClass('show');
        $('.hlogo').addClass('on');
      }else {
        $(this).removeClass('open').siblings('.gnb').removeClass('show');
        $('.hlogo').removeClass('on');
      }
      
    })
    
  }
}
</script>

<style>
  @import '../assets/css/slick.css';
  @import '../assets/css/style.css';
</style>


// WEBPACK FOOTER //
// src/views/COMPANY.vue